import { Link } from 'react-router-dom'
import { slugifyTag } from '@/lib/blog'

interface BlogTagChipProps {
  tag: string
  active?: boolean
}

export function BlogTagChip({ tag, active = false }: BlogTagChipProps) {
  const base = 'inline-flex items-center px-3 py-1 rounded-full text-xs font-semibold transition-colors'
  const styles = active
    ? 'bg-[#237CCA] text-white'
    : 'bg-slate-100 text-slate-600 hover:bg-slate-200'

  return (
    <Link to={`/blog/tag/${slugifyTag(tag)}`} className={`${base} ${styles}`}>
      #{tag}
    </Link>
  )
}
